import { render, staticRenderFns } from "./ComponentsList.vue?vue&type=template&id=acda12d6&scoped=true&"
import script from "./ComponentsList.vue?vue&type=script&lang=ts&"
export * from "./ComponentsList.vue?vue&type=script&lang=ts&"
import style0 from "./ComponentsList.vue?vue&type=style&index=0&id=acda12d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acda12d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VFlex,VImg,VLabel,VLayout,VProgressCircular,VRow})
